import { Directive } from '@angular/core';

@Directive({
  selector: 'cs-button-text',
  standalone: false,
})
export class ButtonTextDirective {}
